import { render, staticRenderFns } from "./GithubButton.vue?vue&type=template&id=abe05a0a&scoped=true&"
var script = {}
import style0 from "./GithubButton.vue?vue&type=style&index=0&id=abe05a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe05a0a",
  null
  
)

export default component.exports